var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.293 1.879a1 1 0 00-1.414 1.414l7.07 7.071-7.07 7.071a1 1 0 101.414 1.415l7.071-7.072 7.071 7.071a1 1 0 001.414-1.414l-7.07-7.07 7.07-7.072a1 1 0 00-1.414-1.414l-7.07 7.071-7.072-7.071z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "1b8e0973eca2fc2765de153a09ce82dd.svg";
export { SvgClose as Component };